import { createElement, setText } from './dom';
import { createIcon } from './icons';
import { setLabel } from './i18n';
import { createMovementSettings } from './movementSettings';

export function createGatewaySettings(parent: HTMLElement) {
  const launcher = createElement('button', 'settings-launcher', parent);
  launcher.type = 'button';
  launcher.setAttribute('aria-haspopup', 'dialog');
  launcher.setAttribute('aria-controls', 'gateway-settings');
  setText(launcher, 'Settings');
  const panel = createElement('dialog', 'gateway-panel settings-panel', parent);
  panel.id = 'gateway-settings';
  panel.setAttribute('aria-labelledby', 'settings-heading');
  const header = createElement('div', 'gateway-panel-header', panel);
  const heading = createElement('h2', '', header);
  heading.id = 'settings-heading';
  setText(heading, 'Settings');
  const close = createElement('button', 'panel-close', header);
  close.type = 'button';
  setLabel(close, 'aria-label', 'Close settings');
  close.append(createIcon('close', 18));
  const controls = createElement('div', 'settings-controls', panel);
  createMovementSettings(panel);
  launcher.addEventListener('click', () => {
    panel.showModal();
  });
  close.addEventListener('click', () => {
    panel.close();
  });
  return {
    controls,
    close: () => {
      panel.close();
    },
  };
}
